import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import MapPage from "./pages/MapPage";
import Article from "./pages/Article";
import About from "./pages/About";
import AdminSubscribers from "./pages/AdminSubscribers";
import AdminDownloads from "./pages/AdminDownloads";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col bg-bg">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/articles/:slug" element={<Article />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin/subscribers" element={<AdminSubscribers />} />
              <Route path="/admin/downloads" element={<AdminDownloads />} />
            </Routes>
          </div>
          <Footer />
          <Chatbot />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
